var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyAlt1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0719 11.1351C9.0889 12.5977 6.28 12.4321 4.48399 10.6384C2.50534 8.66223 2.50534 5.45826 4.48399 3.48211C6.46265 1.50596 9.67068 1.50596 11.6493 3.48211C13.4453 5.27584 13.6111 8.08118 12.1467 10.0617L20.7774 18.6801C21.0742 18.9766 21.0742 19.4572 20.7774 19.7536L18.7507 21.7777C18.4539 22.0741 17.9727 22.0741 17.6759 21.7777C17.3791 21.4813 17.3791 21.0007 17.6759 20.7042L19.1652 19.2169L17.2 17.2542L16.3043 18.1487C16.0075 18.4451 15.5263 18.4451 15.2295 18.1487C14.9327 17.8523 14.9327 17.3717 15.2295 17.0753L16.1252 16.1807L11.0719 11.1351ZM6.27533 8.84931C7.26466 9.83738 8.86868 9.83738 9.858 8.84931C10.8473 7.86123 10.8473 6.25925 9.858 5.27118C8.86868 4.2831 7.26466 4.2831 6.27533 5.27118C5.286 6.25925 5.286 7.86123 6.27533 8.84931Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyAlt1);
export default __webpack_public_path__ + "static/media/key-alt-1.960e5d5a92bd243f1264d2c58f551737.svg";
export { ForwardRef as ReactComponent };